export const DistanceColor = (value) => {
  if(value <= 1) {
    return '#36934F';
  }
  if(value > 1 && value <= 3) {
    return '#49CF77';
  }
  if(value > 3 && value <= 5) {
    return '#FF7C55';
  }
  
  return '#EF4232';
}

/*eslint-disable*/
export const tDateParser = (dateStr) => {
  const JustDate = { key: '', value: [], params: [] };
    
  // Tire karakterlerini standart '-' ile değiştiriyoruz (örneğin '–' veya '—' yerine '-')
  const normalizedStr = dateStr.replace(/–|—/g, '-').trim();

  // Farklı tarih formatları için düzenli ifadeler
  const adPattern = /^AD\s+(\d+)\s*-\s*(\d+)$/i;                 // Örneğin: "AD 750-950"
  const bcPattern = /^(\d+)\s*-\s*(\d+)\s*BC$/i;                 // Örneğin: "600-820 BC"
  const bcAdPattern = /^(\d+)\s*BC\s*-\s*AD\s*(\d+)$/i;         // Örneğin: "856 BC - AD 230"
  const bcAdCombinedPattern = /^BC\s*-\s*AD\s*(\d+)\s*$/i;      // Örneğin: "BC-AD 230"
  const adBcCombinedPattern = /^AD\s*-\s*BC\s*(\d+)\s*$/i;      // Ekstra: "AD-BC 230" (Eğer gerekirse)
  const bcePattern = /^(\d+)\s*-\s*(\d+)\s*BCE$/i;              // Örneğin: "789-546 BCE"
  const cePattern  = /^(\d+)\s*-\s*(\d+)\s*CE$/i;               // Örneğin: "1743-1793 CE"

  let match;
  
  if (match = normalizedStr.match(adPattern)) {
      JustDate.key = 'Date AD';

      JustDate.params = ['{dateAD}'];
      JustDate.value = [match[1] + '-' + match[2]];
  } else if (match = normalizedStr.match(bcPattern)) {
      JustDate.key = 'Date BC';

      JustDate.params = ['{dateBC}'];
      JustDate.value = [match[1] + '-' + match[2]];
  } else if (match = normalizedStr.match(bcAdPattern)) {
      JustDate.key = 'Date BC to AD';

      JustDate.params = ['{dateBC}', '{dateAD}'];
      JustDate.value = [match[1] , match[2]];
  } else if (match = normalizedStr.match(bcePattern)) {
      JustDate.key = 'Date BCE';

      JustDate.params = ['{dateBCE}'];
      JustDate.value = [match[1] + '-' + match[2]];
  } else if (match = normalizedStr.match(cePattern)) {
      JustDate.key = 'Date CE';

      JustDate.params = ['{dateCE}'];
      JustDate.value = [match[1] + '-' + match[2]];
  } else {
      console.error('Unidentified date format:', dateStr);
  }
  // else if (match = normalizedStr.match(bcAdCombinedPattern)) {
  //     JustDate['BC to AD'] = [null, match[1]];
  // } else if (match = normalizedStr.match(adBcCombinedPattern)) {
  //     JustDate['AD to BC'] = [null, match[1]];
  // } 

  return JustDate;
}